import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  getOnboardingState,
  getTenantState,
  getAuthState,
} from '../../../store/selectors';
import { getCurrentUserId, getData } from '../../../store/actions';
import GenericCareerCard from '../../utility/GenericCareerCard';
import CareerCardBubble from '../../utility/CareerCardBubble';

function ECAPCareerCard(props) {
  const { career, degreeTitle, progressByDegree } = {
    ...props,
  };

  const [currentCareer, setCurrentCareer] = useState(career);

  useEffect(() => {
    setCurrentCareer(career);
  }, [currentCareer, career]);

  const totalRequiredClasses = () =>
    progressByDegree.requiredClassesByAcadPlan.length;

  return (
    <div className="career-card-summary-text">
      <CareerCardBubble
        totalRequiredClasses={totalRequiredClasses()}
        color={props.tenant.secondary}
        progressByDegree={props.progressByDegree}
        placedClasses={props.placedClasses}
      />
      <GenericCareerCard
        img={career.image}
        career={career}
        subText={degreeTitle}
        subTextColor={props.tenant.primary}
        innerContainerRadius="9px 0 0 0 !important"
        pictureResultsRadius="9px 0 0 0 !important"
        favorite
        location={props.location}
        tenant={props.tenant}
        alert
      />
    </div>
  );
}

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);
  const auth = getAuthState(state);

  return { onboarding, tenant, auth };
}

export default connect(mapStateToProps, {
  getCurrentUserId,
  getData,
})(ECAPCareerCard);
